import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Login.css"; // Seu arquivo de estilos
import logoLogin from "../images/logo login.svg"; // Imagem de logo (exemplo)

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isPatient, setIsPatient] = useState(true); // Controla o toggle "Sou Paciente"
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  // Limpa o erro quando o usuário modifica os campos
  const handleInputChange = () => {
    if (errorMessage) setErrorMessage("");
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    setErrorMessage(""); // Limpa mensagens de erro anteriores
    setIsLoading(true);
  
    const endpoint = isPatient
      ? "https://x8ki-letl-twmt.n7.xano.io/api:g_BmLeE8/paciente/auth/login"
      : "https://x8ki-letl-twmt.n7.xano.io/api:g_BmLeE8/auth/login";
  
    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });
  
      let data;
      try {
        data = await response.json();
      } catch (jsonError) {
        console.error("Erro ao fazer parse do JSON:", jsonError);
        setErrorMessage("Erro inesperado no servidor. Por favor, tente novamente.");
        setIsLoading(false);
        return;
      }
  
      console.log("Dados recebidos do servidor:", data);
  
      if (!response.ok) {
        const fallbackMessage = "Usuário ou senha inválidos. Por favor, tente novamente.";
        const translated = translateMessage(data?.message || fallbackMessage);
        setErrorMessage(translated);
        setIsLoading(false);
        return;
      }
  
      if (data.authToken) {
        // Armazena o token e o ID no localStorage
        localStorage.setItem("authToken", data.authToken);
        localStorage.setItem("patientId", data.id);
  
        // Redireciona o usuário
        navigate(isPatient ? "/dashpacientes" : "/dashboard");
      } else {
        const fallbackMessage = "Falha na autenticação. Verifique seus dados.";
        const translated = translateMessage(data?.message || fallbackMessage);
        setErrorMessage(translated);
      }
    } catch (error) {
      console.error("Erro de rede ou inesperado:", error);
      setErrorMessage("Erro de conexão. Verifique sua internet ou tente novamente mais tarde.");
    }
  
    setIsLoading(false);
  };

  const translateMessage = (msg) => {
    if (!msg) return "";
  
    if (msg.includes("Invalid Credentials")) return "Usuário ou senha inválidos.";
    if (msg.includes("Invalid password syntax")) return "Formato de senha inválido.";
    if (msg.includes("ACCESS_DENIED")) return "Acesso negado. Verifique suas permissões.";
    if (msg.includes("FATAL")) return "Erro fatal no login. Contate o suporte.";
  
    return msg; // Se não reconhecido, retorna como está
  };
  

  return (
    <div className="login-container">
      <div className="login-box">
        {/* Logo (opcional) */}
        <img src={logoLogin} alt="Logo Login" />

        {/* Mensagem de erro sempre no DOM, mas visível apenas quando há erro */}
        <div className="error-message" style={{ display: errorMessage ? 'block' : 'none' }}>
          {errorMessage || "Ocorreu um erro. Por favor, tente novamente."}
        </div>

        <form onSubmit={handleLogin}>
          {/* Campo de Email */}
          <div className="input-group">
            <label htmlFor="email">Email</label>
            <input
              type="text"
              id="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                handleInputChange();
              }}
              required
            />
          </div>

          {/* Campo de Senha */}
          <div className="input-group">
            <label htmlFor="password">Senha</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                handleInputChange();
              }}
              required
            />
          </div>

          {/* Toggle "Sou Paciente" */}
          <div className="toggle-switch">
            <label htmlFor="is_patient">Sou Paciente</label>
            <input
              type="checkbox"
              id="is_patient"
              checked={isPatient}
              onChange={() => {
                setIsPatient(!isPatient);
                handleInputChange();
              }}
            />
            <label className="slider round" htmlFor="is_patient"></label>
          </div>

          {/* Botão de Enviar */}
          <div className="input-group">
            <button type="submit" disabled={isLoading}>
              {isLoading ? "Entrando..." : "Entrar"}
            </button>
          </div>

          {/* Link para registro */}
          <div className="input-group">
            <button
              type="button"
              style={{
                background: "none",
                border: "none",
                color: "#2558a6",
                cursor: "pointer",
                padding: 0,
              }}
              onClick={() => navigate("/register")}
            >
              Não tem uma conta? Registre-se
            </button>
          </div>
          
          {/* Link para recuperação de senha */}
          <div className="input-group">
            <button
              type="button"
              style={{
                background: "none",
                border: "none",
                color: "#2558a6",
                cursor: "pointer",
                padding: 0,
                marginTop: "-10px",
              }}
              onClick={() => navigate("/forgot-password")}
            >
              Esqueceu sua senha?
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
